import { render, staticRenderFns } from "./RegisterSubModuleCustomization.vue?vue&type=template&id=50fb015d&scoped=true&"
import script from "./RegisterSubModuleCustomization.vue?vue&type=script&lang=js&"
export * from "./RegisterSubModuleCustomization.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSubModuleCustomization.vue?vue&type=style&index=0&id=50fb015d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb015d",
  null
  
)

export default component.exports